/**
 * @generated SignedSource<<1772ac24aac20f5b55c1898dd51e3634>>
 * @relayHash 617fa524f6cdb1d401e00a4ea5aa7c6a
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 617fa524f6cdb1d401e00a4ea5aa7c6a

import { ConcreteRequest } from 'relay-runtime';
export type externalAssistanceInformationDialogQuery$variables = {
  id: string;
};
export type externalAssistanceInformationDialogQuery$data = {
  readonly ch_externalAssistanceInfos: {
    readonly insureeNumber: string | null;
    readonly name: string;
    readonly organizationName: string;
    readonly phoneNumber: string;
  } | null;
};
export type externalAssistanceInformationDialogQuery = {
  response: externalAssistanceInformationDialogQuery$data;
  variables: externalAssistanceInformationDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "patientId",
        "variableName": "id"
      }
    ],
    "concreteType": "ExternalAssistanceInfos",
    "kind": "LinkedField",
    "name": "ch_externalAssistanceInfos",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "insureeNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizationName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phoneNumber",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "externalAssistanceInformationDialogQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "externalAssistanceInformationDialogQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "617fa524f6cdb1d401e00a4ea5aa7c6a",
    "metadata": {},
    "name": "externalAssistanceInformationDialogQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6ceccdac4db7755b63e2ed6174ac8822";

export default node;
